import React from 'react'

const Manual_configurar_horarios_pedidos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configurar horarios que se aceptan pedidos
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Define los horarios en los que tu tienda acepta pedidos de clientes dentro del portal de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configurar_horarios_que_se_aceptan_pedidos__UAIObBr7TQCn5DxN3PV4Sg?as=scrollable"
          className="scribe-iframe-general-112"
          width="100%"
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configurar_horarios_pedidos
